import {
    REQUEST_ASSISTANTS,
    RECEIVE_ASSISTANTS,
    RELOAD_ASSISTANTS,
    UPDATE_ASSISTANTS,
    ERROR_ASSISTANTS
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"


export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_ASSISTANTS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_ASSISTANTS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                shouldReload: false,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case RELOAD_ASSISTANTS:
            return {
                ...state,
                shouldReload: true
            }
        case UPDATE_ASSISTANTS:
            const data = state.data
            let index = null
            if(data.results){
                if(action.updateType == "delete"){
                    index = data.results.findIndex(item => item.id == action.id)
                    data.results.splice(index, 1)
                }else{
                    index = data.results.findIndex(item => item.id == action.id)
                    if(index > -1){
                        data.results[index] = action.payload
                    }else{
                        data.results.unshift(action.payload)
                    }
                }
            }
            return {
                ...state,
                isFetching: false,
                data,
                errors: action.errors
            }
        case ERROR_ASSISTANTS:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}